import React from "react";
import { RightOutlined } from "@ant-design/icons";
import { Flex, Typography, Button, Row, Col } from "antd";
import { useTranslation } from "react-i18next";

import { SectionTitle, SectionContentWrapper, Section } from "./styled";
import { useCategories, useTopStaff } from "./hooks";
import { Category, Staff } from "./components";
import { HeroSection } from "./components/HeroSection";
import { HowItWorks } from "./components/HowItWorks";
import { Advantages } from "./components/Advantages";
import { Statistics } from "./components/Statistics";
import { CTASection } from "./components/CTASection";
import { MobileApp } from "./components/MobileApp";
import { Footer } from "./components/Footer";

const Home: React.FC = () => {
  const { t } = useTranslation();
  const { categories } = useCategories();
  const { staff } = useTopStaff();

  return (
    <Flex vertical>
      <HeroSection />

      <Section>
        <SectionContentWrapper>
          <Flex vertical gap="middle">
            <Flex justify="space-between" align="center" style={{ marginBottom: 24 }}>
              <Flex vertical align="flex-start">
                <SectionTitle level={2} style={{ marginBottom: 8 }}>
                  {t("home.categories.title")}
                </SectionTitle>
                <Typography.Text type="secondary" style={{ fontSize: 16 }}>
                  {t("home.categories.subtitle")}
                </Typography.Text>
              </Flex>
              <Button
                type="text"
                size="large"
                style={{ color: "#6C5CE7", fontWeight: 600 }}
                icon={<RightOutlined />}
                iconPosition="end"
              >
                {t("home.categories.viewAll")}
              </Button>
            </Flex>
            <Row gutter={[24, 24]}>
              {categories.map((category) => (
                <Col key={category.id} xs={24} sm={12} md={8}>
                  <Category key={category.id} category={category} />
                </Col>
              ))}
            </Row>
          </Flex>
        </SectionContentWrapper>
      </Section>

      <HowItWorks />

      <Section>
        <SectionContentWrapper>
          <Flex vertical gap="middle">
            <Flex justify="space-between" align="end" style={{ marginBottom: 16 }}>
              <div>
                <SectionTitle level={2} style={{ marginBottom: 4 }}>
                  {t("home.specialists.title")}
                </SectionTitle>
                <Typography.Text type="secondary">{t("home.specialists.subtitle")}</Typography.Text>
              </div>
              <Typography.Link
                style={{
                  color: "#6C5CE7",
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                }}
              >
                {t("home.specialists.viewAll")} <RightOutlined style={{ fontSize: 12 }} />
              </Typography.Link>
            </Flex>

            <Row gutter={[24, 24]}>
              {staff.map((member) => (
                <Col key={member.id} xs={24} sm={12} md={12} lg={6}>
                  <Staff key={member.id} staff={member} />
                </Col>
              ))}
            </Row>
          </Flex>
        </SectionContentWrapper>
      </Section>

      <Advantages />

      <Statistics />

      <Section>
        <SectionContentWrapper>
          <CTASection />
        </SectionContentWrapper>
      </Section>

      <MobileApp />

      <Footer />
    </Flex>
  );
};

export default Home;
